import FlowDesigner from './src/FlowDesigner.vue';

// 为组件提供 install 安装方法，供按需引入
// FlowDesigner.install = (Vue) => {
//   Vue.component(FlowDesigner.name, FlowDesigner);
// };

export default FlowDesigner;
